import { sendApiRequest } from "../lib/helper";
import { IAssignment, ICourseWorkFlat, IStudentFolder } from "../types/IAssignment";
import { ICourseWorkTagMapping } from "../types/IAssignmentTags";

export const getCourseWorks = (assignment: IAssignment): Promise<ICourseWorkFlat[]> => {
    return sendApiRequest(`/api/blobStorage/getCourseWorkFromBlobStorage`, "POST", JSON.stringify({assignment: assignment})).then(response => {
        const retVal: ICourseWorkFlat[] = [] 
        response.Folders.forEach((f: IStudentFolder) => {        
            f.Files.forEach(file => {
                const courseWork: ICourseWorkFlat = {
                    ...file,
                    Student: f.Student,
                    Tags: file.Metadata?.Tags?.split(";") || [],
                    MatchesCurrentSearch: true
                };        
                retVal.push(courseWork);
            })                   
        });

        return retVal;
    });
};

export const updateCourseWorkTags = (courseWorkTagMapping: ICourseWorkTagMapping) => {
    return sendApiRequest(`/api/blobStorage/updateCourseWorkTags`, "PATCH", JSON.stringify({courseWorkMapping: courseWorkTagMapping}));
}

export const updateHiddenCourseworkForAccreditor = (artifactPath: string, isVisible: boolean) => {
    return sendApiRequest(`/api/sql/updateHiddenCourseworkForAccreditor?&Visible=${isVisible}`, "POST", JSON.stringify({CourseWorkPath: artifactPath}));
}

export const updateHiddenCoursework = (artifactPath: string, isVisible: boolean) => {
    return sendApiRequest(`/api/sql/updateHiddenCoursework?&Visible=${isVisible}`, "POST", JSON.stringify({CourseWorkPath: artifactPath}));
}

export const renameBlobFile = (oldPath: string, newPath: string) => {
    return sendApiRequest(`/api/blobStorage/renameBlobFile`, "PATCH", JSON.stringify({newBlobPath: newPath, oldBlobPath: oldPath}));
}

export const getHiddenCouresworksForAccreditor = () => {
    return sendApiRequest(`/api/sql/getHiddenCouresworksForAccreditor`, "GET").then((hiddenCW: any[]) => {
        return hiddenCW.map(c => c.BlobPath);
    });
}